export default __webpack_public_path__ + "public/icons/qality-issue-icon.png?e80b33b4edbb95eb788e24871b836823";